import { IState } from '../../../store';
import { offerDataSelector } from '../offerDataSelector';

export function offerSelector(state: IState) {
  return offerDataSelector(state).offer;
}
